import Hero from "../components/Hero";
import HeroImage from "../../assets/images/OurTeam1.jpg";
import MichaelImage from "../../assets/images/OurTeam2.jpg";
import OutlinedButton from "../designSystem/OutlinedButton";
import ConorImage from "../../assets/images/OurTeam3.jpg";
import FilledButton from "../designSystem/FilledButton";
import OutlinedLightButton from "../designSystem/OutlinedLightButton";
import DavidImage from "../../assets/images/OurTeam4.jpg";
import BeckiImage from "../../assets/images/OurTeam5.jpg";
import LauraImage from "../../assets/images/OurTeam6.jpg";

const OurTeamPage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Our Team"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="white-container">
        <div className="white-container-content">
          <div className="row">
            <img
              src={MichaelImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
            <div className="content-column">
              <h2 className="burgandy align-left">Michael Welton</h2>
              <div className="row">
                <FilledButton
                  text="07791 445522"
                  onClick={() => window.open("tel:07791445522", "_self")}
                />
                <FilledButton
                  text="michael@wppfs.co.uk"
                  onClick={() =>
                    window.open("mailto:michael@wppfs.co.uk", "_self")
                  }
                />
              </div>
              <div className="content-semibold grey align-left">
                Managing Director - Residential, Remortgage and Purchase
                Specialist
              </div>
              <div className="content grey align-left">
                Michael has worked in Financial Services since 2003, working
                with companies such as Woolwich, Barclays and St James’s Place.
                He prides himself on giving straightforward, easy to understand
                advice.
              </div>
              <OutlinedButton
                text="Book a FREE initial appointment with Michael"
                onClick={() => {
                  window.open(
                    "https://calendly.com/michaelweltonmortgageadvice/30min",
                    "_blank",
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="burgandy-container">
        <div className="burgandy-container-content">
          <div className="row">
            <img
              src={ConorImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
            <div className="content-column">
              <h2 className="white align-left">Conor Slatter</h2>
              <div className="row">
                <OutlinedLightButton
                  text="07979186801"
                  onClick={() => window.open("tel:07979186801", "_self")}
                />
                <OutlinedLightButton
                  text="conor@wppfs.co.uk"
                  onClick={() =>
                    window.open("mailto:conor@wppfs.co.uk", "_self")
                  }
                />
              </div>
              <div className="content-semibold align-left">
                Specialist lending for buy-to-let portfolios
              </div>
              <div className="content align-left">
                Conor has worked in Customer Services since 2011 and had taken
                that passion and experience with him when he started working for
                Nationwide in 2016. Since working in Financial Services he has
                developed a real passion for helping people with their mortgages
                and has moved to WPP Financial Services to make that dream a
                reality. He prides himself on honest, easy to understand advice
                which will benefit his clients not only now but in the future.
              </div>
              <OutlinedLightButton
                text="Book a FREE initial appointment with Conor"
                onClick={() => {
                  window.open(
                    "https://calendly.com/cs-mortgage/30min?month=2026-04",
                    "_blank",
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <img
              src={DavidImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
            <div className="content-column">
              <h2 className="burgandy align-left">David Buckland</h2>
              <div className="row">
                <FilledButton
                  text="07843 437408"
                  onClick={() => window.open("tel:07843437408", "_self")}
                />
                <FilledButton
                  text="david@wppfs.co.uk"
                  onClick={() =>
                    window.open("mailto:david@wppfs.co.uk", "_self")
                  }
                />
              </div>
              <div className="content-semibold grey align-left">
                Adverse Credit and Debt Consolidation Specialist
              </div>
              <div className="content grey align-left">
                David has worked as a Regional Manager in a sales based
                environment since 2006 working for McCurrach UK ltd. He joined
                WPP Financial Services in 2018 and enjoys using his experience
                in customer service to help clients with their mortgage and
                protection needs. He believes in cutting through the jargon to
                give straightforward and honest advice which gives clients their
                best possible outcome. Away from work he enjoys spending time
                with his wife and 2 kids as well as running and restoring his
                classic car.
              </div>
              <OutlinedButton
                text="Book a FREE initial appointment with David"
                onClick={() => {
                  window.open(
                    "https://calendly.com/davidbucklandmortgageadvice/mortgage-advice-30-minute-meeting?month=2026-04",
                    "_blank",
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="white-container">
        <div className="white-container-content">
          <div className="row flex-start">
            <div className="content-column">
              <img
                src={BeckiImage}
                alt="WPP Financial Services Building"
                className="image-container"
                style={{ width: "100%" }}
              />
              <h2 className="burgandy align-left">Becki Prince</h2>
              <div className="row">
                <FilledButton
                  text="07733 709566"
                  onClick={() => window.open("tel:07733709566", "_self")}
                />
                <FilledButton
                  text="becki@wppfs.co.uk"
                  onClick={() =>
                    window.open("mailto:becki@wppfs.co.uk", "_self")
                  }
                />
              </div>
              <div className="content-semibold grey align-left">
                Executive Assistant
              </div>
              <div className="content grey align-left">
                Becki is the newest member to WPP joining in June 2025. Becki
                brings over 20 years of extensive experience in administration
                and Executive Assistant roles, primarily within a large
                executive charity. Her background has honed exceptional customer
                service skills, and she is dedicated to providing every client
                with a professional yet friendly approach.
              </div>
            </div>
            <div className="content-column">
              <img
                src={LauraImage}
                alt="WPP Financial Services Building"
                className="image-container"
                style={{ width: "100%" }}
              />
              <h2 className="burgandy align-left">Laura Hargreaves</h2>
              <div className="row">
                <FilledButton
                  text="laura@wppfs.co.uk"
                  onClick={() =>
                    window.open("mailto:laura@wppfs.co.uk", "_self")
                  }
                />
              </div>
              <div className="content-semibold grey align-left">
                Executive Assistant
              </div>
              <div className="content grey align-left">
                Laura joined WPP in June 2022 with over 20 years’ experience in
                her previous administrative role. She is committed to providing
                excellent service to clients and the team in a friendly and
                efficient manner.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeamPage;
